<panel width="600">
	<h1>{{ 'order.edit-order-externals.headline' | translate }}</h1>
	<section>
		<reason-select #reasons [label]="'order.edit-order-externals.select-discount-reason' | translate" [(reasonId)]="selectedDiscountReasonId" [type]="reasonType.Discount" />
		<custom-input [label]="'order.edit-order-externals.discount-amount' | translate" [inputType]="inputType.Currency" [(value)]="discountAmount" />
		<custom-input [label]="'order.edit-order-externals.remaining-amount' | translate" [inputType]="inputType.Currency" [(value)]="remainingAmount" />
		<custom-input [label]="'order.edit-order-externals.annual-value-for-renewal' | translate" [inputType]="inputType.Currency" [(value)]="annualValueForRenewal" />
	</section>
	<section>
		<button confirm (click)="save()">{{ 'general.save' | translate }}</button>
	</section>
</panel>
